const validate = values => {
  const errors = {}

  if (!values.countdown_clock_feature_form?.title) {
    errors.countdown_clock_feature_form = {
      ...errors.countdown_clock_feature_form,
      title: "The countdown clock title is required!",
    }
  }

  if (
    !values.countdown_clock_feature_form?.date ||
    !values.countdown_clock_feature_form?.hour ||
    !values.countdown_clock_feature_form?.minute
  ) {
    errors.countdown_clock_feature_form = {
      ...errors.countdown_clock_feature_form,
      date: "The date and time are required!",
    }
  }

  if (
    values.countdown_clock_feature_form?.hour < 0 ||
    values.countdown_clock_feature_form?.hour > 12 ||
    values.countdown_clock_feature_form?.minute < 0 ||
    values.countdown_clock_feature_form?.minute > 59
  ) {
    errors.countdown_clock_feature_form = {
      ...errors.countdown_clock_feature_form,
      date: "Invalid time format",
    }
  }

  const inputDate = new Date(
    `${values.countdown_clock_feature_form?.date} ${values.countdown_clock_feature_form?.hour}:${values.countdown_clock_feature_form?.minute} ${values.countdown_clock_feature_form?.timeType} `
  )
  const currentDate = new Date()
  if (inputDate < currentDate) {
    errors.countdown_clock_feature_form = {
      ...errors.countdown_clock_feature_form,
      date: "The date must be after the current date!",
    }
  }

  return errors
}

export default validate
